import { render } from "./invoice.vue?vue&type=template&id=f661b6e2&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"

import "./invoice.vue?vue&type=style&index=0&id=f661b6e2&lang=scss&scoped=true"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f661b6e2"]])

export default __exports__